var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayerWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.627,
    height: 12.014,
    stroke: "#5300f2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Group 579"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 349",
    d: "M13.281 2.829L7.051.051a.58.58 0 00-.475 0L.346 2.829a.583.583 0 00-.037 1.047l6.23 3.322a.584.584 0 00.549 0l6.23-3.322a.583.583 0 00-.038-1.047z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 350",
    d: "M12.769 5.315L6.813 8.492.858 5.315a.583.583 0 00-.549 1.029l6.23 3.323a.585.585 0 00.549 0l6.23-3.323a.583.583 0 00-.55-1.029z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 351",
    d: "M12.769 7.594L6.813 10.77.858 7.594a.583.583 0 10-.549 1.029l6.23 3.322a.582.582 0 00.549 0l6.23-3.322a.583.583 0 10-.55-1.029z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayerWhite);
export default __webpack_public_path__ + "static/media/layerWhite.e4cd5b57ecb2795522ffb0db8c99ae5b.svg";
export { ForwardRef as ReactComponent };